import VariableCardList from './VariableCardList';
import { VariableCardListProps, VariableCardListValueProps } from './types';

export type { VariableCardListProps, VariableCardListValueProps };
export default VariableCardList;
